module.exports = __webpack_public_path__ + "ac1c54d5acb9566df86850ec82c8f980.svg";